import React, { useEffect, useState, Fragment } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import Slider from "react-slick"; // Import the slider
import { useDispatch, useSelector } from "react-redux";
import { getFeedbackRequest } from "../../redux/jobseeker/get_feedback/actions";
import Spinner from "../../Components/Common/Spinner";
import { getOnlineCourseRequest } from "../../redux/jobseeker/get_online_course/actions";
import star_blank from "../../assets/images/star/star_blank.png";
import star_half from "../../assets/images/star/star_half.png";
import star from "../../assets/images/star/star.png";
import { Link } from "react-router-dom";
import { capitalize, generateSlug, formatExperienceOutput, timeAgo } from "../../Components/Common/CommonFunction";
import {
  communicationsOptions,
  contactibilityOptions,
  technicalSkillsOptions,
  softSkillsOptions,
  experienceFitOptions,
} from "../../Constant";
import NoDataFound from "../../Components/Common/NoDataFound"; // Import the NoDataFound component
import DataTable from "react-data-table-component"; // Import DataTable
const CustomHeader = ({ cell }) => (
  <th style={{ fontWeight: "bold" }}>{cell.label}</th>
);
// const CourseCard = ({ course }) => {
//   const [isHovered, setIsHovered] = useState(false);

//   const hoverStyle = {
//     transform: isHovered ? "scale(1.1)" : "scale(1)", // Increased scale for a more pronounced effect
//     boxShadow: isHovered
//       ? "0 12px 24px rgba(0, 0, 0, 0.15)"
//       : "0 4px 12px rgba(0, 0, 0, 0.05)",
//     transition: "transform 0.3s ease, box-shadow 0.3s ease",
//   };


//   return (
//     <div className="p-3">
//       <a
//         href={course.link}
//         // href={`course_detail.php?title=${encodeURIComponent(course.title)}&course_uuid=${course.uuid}`}
//         target="_blank"
//         rel="noopener noreferrer"
//         className="text-decoration-none text-dark"
//       >
//         <div
//           className="card h-100 rounded-4"


//         >
//           {/* Top Info */}
//           <div className="px-3 pt-3 d-flex flex-wrap justify-content-between align-items-center">
//             {/* Uncomment if you want to display the views section */}
//             {/* <div className="d-flex align-items-center text-muted small">
//     <img
//       src="/assets/img/views.png"
//       alt="views"
//       className="me-1"
//       style={{ width: 16, height: 16 }}
//     />
//     <span>{course.postedAgo}</span>
//   </div> */}

//             <div className="d-flex align-items-center flex-wrap">
//               {(() => {
//                 const fullStars = Math.floor(course.course_rating);
//                 const hasHalfStar = course.course_rating % 1 >= 0.5;
//                 const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//                 const stars = [];

//                 for (let i = 0; i < fullStars; i++) {
//                   stars.push(
//                     <img
//                       key={`full-${i}`}
//                       src={star}
//                       alt="full star"
//                       style={{ width: 14, height: 14, marginRight: "2px" }}
//                     />
//                   );
//                 }

//                 if (hasHalfStar) {
//                   stars.push(
//                     <img
//                       key="half"
//                       src={star_half}
//                       alt="half star"
//                       style={{ width: 14, height: 14, marginRight: "2px" }}
//                     />
//                   );
//                 }

//                 for (let i = 0; i < emptyStars; i++) {
//                   stars.push(
//                     <img
//                       key={`empty-${i}`}
//                       src={star_blank}
//                       alt="empty star"
//                       style={{ width: 14, height: 14, marginRight: "2px" }}
//                     />
//                   );
//                 }

//                 return stars;
//               })()}
//               <small className="ms-1 text-muted">{course.course_rating}</small>
//             </div>

//             <span className="badge text-uppercase" style={{ fontSize: "10px", backgroundColor: "hsl(0, 0%, 90%)", color: "black" }}>
//               English
//             </span>
//           </div>


//           {/* Course Image */}
//           <div className="px-3 py-3 text-center">
//             <img
//               src={course.course_image}
//               alt={course.title}
//               className="img-fluid"
//               // style={{ maxHeight: 140, objectFit: "contain" }}
//               style={hoverStyle}
//               onMouseEnter={() => setIsHovered(true)}
//               onMouseLeave={() => setIsHovered(false)}
//             />
//           </div>

//           {/* Title, Duration & Price */}
//           <div className="card-body pt-0 pb-2 px-3 text-center">
//             <h6 className="fw-semibold text-dark mb-1">{course.title}</h6>
//             <p className="text-muted small mb-2">{course.course_duration}</p>

//             <div className="d-flex justify-content-center align-items-center mb-2">
//               <h5 className="text-warning fw-bold mb-0 me-2">₹{course.price}</h5>
//               {course.onDiscount && (
//                 <>
//                   <small className="text-muted me-2">{course.discount}% off</small>
//                   <del className="text-muted small">₹{course.originalPrice}</del>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer */}
//           <div className="card-footer bg-light d-flex justify-content-between align-items-center px-3 py-2">
//             <small className="text-muted">{course.provider}</small>
//             <a
//               href={course.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="btn btn-sm fw-semibold text-white"
//               style={{
//                 background: "linear-gradient(to right, #0d6efd, #0b5ed7)",
//                 padding: "6px 14px",
//                 borderRadius: "6px",
//                 color: "#fff", // Optional: ensures text is readable
//               }}
//             >
//               ENROLL NOW
//             </a>
//           </div>
//         </div>
//       </a>
//     </div>
//   );
// };


// 1. Component to inject CSS directly into the document head
const CourseCardStyles = () => (
  <style>
    {`
      /* Custom properties for easy color management */

      /* NEW CSS FOR IMAGE ZOOM */

      /* 1. The container that clips the image */
      .course-image-container {
        overflow: hidden;
        border-radius: 4px;
      }
      
      /* 2. The image itself, with a smooth transition */
      .course-image {
        /* CHANGE HERE: Slower transition for a smoother, larger zoom */
        transition: transform 0.4s ease;
      }
      
      /* 3. When the card is hovered, scale up the image */
      .course-card-wrapper:hover .course-image {
        /* CHANGE HERE: Increased zoom effect */
        transform: scale(1.25);
      }
        
      :root {
          --custom-orange: #FF8C42;
          --custom-red: #EC5A58;
          --custom-light-purple: #F4EBFF;
          --custom-pink-hover: #fda0c6;
          --custom-text-muted: #6e6e6e;
      }

      /* Custom Text & Background Colors */
      .text-custom-orange { color: var(--custom-orange) !important; }
      .text-custom-muted { color: var(--custom-text-muted) !important; }
      .bg-custom-light-purple { background-color: var(--custom-light-purple) !important; }
      
      /* Card hover effect */
      .course-card-wrapper {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
      }
      .course-card-wrapper:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
      }

      /* Hover effect for footers */
      .course-card-wrapper:hover .info-footer {
          background-color: var(--custom-pink-hover) !important;
          transition: background-color 0.3s ease-in-out;
      }
      
      /* Custom button with gradient */
      .btn-enroll {
          background-image: linear-gradient(to bottom right, var(--custom-orange), var(--custom-red));
          border: none;
          padding: .65rem 1.5rem;
          font-size: 1 rem;
      }
      .btn-enroll:hover {
          color: white;
          opacity: 0.9;
      }

      /* Line clamping utility */
      .line-clamp-2 {
          display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
          overflow: hidden; text-overflow: ellipsis; white-space: normal; min-height: 2rem; 
      }
      .line-clamp-3 {
          display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical;
          overflow: hidden; text-overflow: ellipsis; white-space: normal; min-height: 4.5rem;
      }
      
      /* --- NEW CSS FOR IMAGE ZOOM --- */

      /* 1. The container that clips the image */
      .course-image-container {
        overflow: hidden;
        border-radius: 4px; /* Optional: adds a nice touch */
      }
      
      /* 2. The image itself, with a smooth transition */
      .course-image {
        transition: transform 0.35s ease;
      }
      
      /* 3. When the card is hovered, scale up the image */
      .course-card-wrapper:hover .course-image {
        transform: scale(1.5);
      }
    `}
  </style>
);
const CourseCard = ({ course }) => {
  // 1. Call all hooks at the top level, before any conditional returns.
  // This ensures they are called in the same order on every render.
  const [isHovered, setIsHovered] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);

  // 2. Now, perform conditional checks for an "early return".
  // This is safe because the hooks have already been called.
  if (!course) {
    return null; // Or return a loading skeleton component
  }

  // --- Logic (can now safely use the `course` prop) ---
  const isFree = !course.price || parseFloat(course.price) === 0;

  // --- Helper Components & Functions ---
  const HeartIcon = ({ filled }) => (
    <svg id="wishlist-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 20" fill={filled ? "#FE8A43" : "none"}>
      <path d="M16.7704 11.7921C18.1054 10.484 19.4583 8.91608 19.4583 6.86432C19.4583 5.55739 18.9392 4.30398 18.015 3.37984C17.0909 2.4557 15.8375 1.93652 14.5305 1.93652C12.9536 1.93652 11.8426 2.38451 10.4987 3.72845C9.15475 2.38451 8.04376 1.93652 6.46686 1.93652C5.15993 1.93652 3.90652 2.4557 2.98238 3.37984C2.05824 4.30398 1.53906 5.55739 1.53906 6.86432C1.53906 8.92504 2.88301 10.493 4.22695 11.7921L10.4987 18.0639L16.7704 11.7921Z" stroke="#FE8A43" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );

  const renderStars = (rating) => {
    const numStars = Math.round(parseFloat(rating));
    if (isNaN(numStars)) return null;
    return Array.from({ length: 5 }, (_, i) => (
      <img key={i} src="./assets/img/star.png" alt="star" style={{ height: '20px', opacity: i < numStars ? 1 : 0.3 }} />
    ));
  };

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsWishlisted(!isWishlisted);
  };

  // --- Styles ---
  const cardStyle = {
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    transform: isHovered ? 'translateY(-5px)' : 'translateY(0)',
    boxShadow: isHovered ? '0 8px 16px rgba(0,0,0,0.1)' : '0 1px 3px rgba(0,0,0,0.05)',
  };

  return (
    <div className="p-2">
      <a
        href={course.link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-decoration-none"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Mobile View */}
        <div className="d-sm-none">
          <div className="bg-white d-flex flex-column rounded-3 course-card-wrapper" style={cardStyle}>
            <div className="d-flex justify-content-between align-items-center p-2">
              <div className="d-flex align-items-center text-secondary">
                <img src="./assets/img/views.png" alt="views" style={{ height: '24px' }} className="me-1" />
                <span className="fw-bolder">| {course.postedAgo}</span>
              </div>
              <div className="d-flex align-items-center">
                {(() => {
                  const fullStars = Math.floor(course.course_rating);
                  const hasHalfStar = course.course_rating % 1 >= 0.5;
                  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

                  const stars = [];

                  for (let i = 0; i < fullStars; i++) {
                    stars.push(
                      <img
                        key={`full-${i}`}
                        src={star}
                        alt="full star"
                        style={{ width: 14, height: 14, marginRight: "2px" }}
                      />
                    );
                  }

                  if (hasHalfStar) {
                    stars.push(
                      <img
                        key="half"
                        src={star_half}
                        alt="half star"
                        style={{ width: 14, height: 14, marginRight: "2px" }}
                      />
                    );
                  }

                  for (let i = 0; i < emptyStars; i++) {
                    stars.push(
                      <img
                        key={`empty-${i}`}
                        src={star_blank}
                        alt="empty star"
                        style={{ width: 14, height: 14, marginRight: "2px" }}
                      />
                    );
                  }

                  return stars;
                })()}
                <small className="ms-1 text-muted">{course.course_rating}</small>
              </div>
              <div className="bg-light p-1 rounded-2"><p className="m-0 small fw-bold">{course.language}</p></div>
            </div>
            <div className="d-flex w-100 p-2">
            <div className="w-33 d-flex justify-content-center align-items-center me-2 course-image-container">
                <img 
                  className="img-fluid course-image"
                  style={{ width: '100%', height: 'auto', objectFit: 'contain', maxHeight: '120px' }}
                  src={course.course_image}
                  alt={course.title}
                />
            </div>
              <div className="d-flex flex-column w-66">
                <p className="line-clamp-3 fw-medium fs-6 m-0 mb-2">{course.title}</p>
                <div className="d-flex align-items-baseline">
                  <p className="fw-bolder text-custom-orange fs-2 me-2 mb-0">{isFree ? 'Free' : `₹${course.price}`}</p>
                  {isFree && <p className="text-custom-muted fs-6 me-2 mb-0">100% Off</p>}
                  {course.originalPrice > course.price && <s className="text-custom-muted fs-6 mb-0">₹{course.originalPrice}</s>}
                </div>
              </div>
            </div>
            <div className="info-footer bg-custom-light-purple d-flex justify-content-between align-items-center p-2 rounded-bottom-3">
              <div style={{ width: '7rem', height: '50px' }} className="d-flex justify-content-center align-items-center">
                <img className="h-75" style={{ objectFit: 'contain' }} src={course.provider_logo} alt="Provider" />
              </div>
              <span className="btn btn-enroll text-white fw-normal rounded-3">ENROLL NOW</span>
            </div>
          </div>
        </div>

        {/* Desktop View */}
        <div className="d-none d-sm-block">
          <div className="bg-white d-flex flex-column h-100 rounded-3 course-card-wrapper" style={cardStyle}>
            <div className="d-flex justify-content-between align-items-center px-3 " style={{ height: '50px' }}>
              <img src={course.platform_image} alt="Provider" style={{ height: '15px' }} />
              <div className="d-flex align-items-center">
                {(() => {
                  const fullStars = Math.floor(course.course_rating);
                  const hasHalfStar = course.course_rating % 1 >= 0.5;
                  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

                  const stars = [];

                  for (let i = 0; i < fullStars; i++) {
                    stars.push(
                      <img
                        key={`full-${i}`}
                        src={star}
                        alt="full star"
                        style={{ width: 14, height: 14, marginRight: "1px" }}
                      />
                    );
                  }

                  if (hasHalfStar) {
                    stars.push(
                      <img
                        key="half"
                        src={star_half}
                        alt="half star"
                        style={{ width: 14, height: 14, marginRight: "1px" }}
                      />
                    );
                  }

                  for (let i = 0; i < emptyStars; i++) {
                    stars.push(
                      <img
                        key={`empty-${i}`}
                        src={star_blank}
                        alt="empty star"
                        style={{ width: 14, height: 14, marginRight: "1px" }}
                      />
                    );
                  }

                  return stars;
                })()}
                <small className="ms-1 text-muted">{course.course_rating}</small>
              </div>
              {/* <div className="bg-light p-1 rounded-2"><p className="m-0 small fw-bold">{course.language}</p></div> */}
            </div>
            <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
              <div className="text-center course-image-container" style={{ height: '160px' }}>
                <img 
                  className="img-fluid p-2 course-image"
                  style={{ width: '100%', height: 'auto', maxHeight: '140px', objectFit: 'contain' }}
                  src={course.course_image}
                  alt={course.title}
                />
              </div>
              <div className="px-3"><p className="line-clamp-2 text-black fs-7 text-center m-0 p-0">{course.title}</p></div>
            </div>
            {/* <div className="d-flex justify-content-start px-3 my-2">
              <button className="btn p-0 border-0" onClick={handleWishlistClick}>
                <HeartIcon filled={isWishlisted} />
              </button>
            </div> */}
            <div className="d-flex justify-content-center align-items-baseline mx-2 p-2 pb-3">
              <p className=" text-custom-orange fs-5 me-2 mb-0">{isFree ? 'Free' : `₹${course.price}`}</p>
              {course.original_price > course.price && <s className="text-custom-muted fs-6 mb-0">₹{course.original_price}</s>}
            </div>
            <div className="info-footer bg-custom-light-purple p-3 d-flex justify-content-center align-items-center rounded-bottom-3">
              <div className="fw-bolder small text-muted mt-1 me-3 mb-0">{timeAgo(course.created_at)}</div>
              <span className="btn btn-enroll text-white text-center rounded-3">ENROLL NOW</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

const JobseekerFeedbackPage = () => {
  const dispatch = useDispatch();
  const totalFeedbackCount = useSelector(
    (state) => state.getFeedbackReducer.total
  );
  const loadingFeedback = useSelector(
    (state) => state.getFeedbackReducer.isLoading
  );

  const feedbackData = useSelector(
    (state) => state.getFeedbackReducer.data
  );
  console.log("feedbackData", feedbackData);

  // const feedbackData = [
  //   {
  //     id: 1,
  //     contactibility: "NOT_REACHABLE",
  //     communication: "WRITTEN_SKILLS",
  //     technical_skills: "CODING_LANGUAGES",
  //     soft_skills: "TEAMWORK_COLLABORATION",
  //     experience_fit: "Good Fit",
  //     candidate_rating: 4,
  //     candidateName: "Archana",
  //   },
  //   {
  //     id: 2,
  //     contactibility: "CALL_LATER",
  //     communication: "WRITTEN_SKILLS",
  //     technical_skills: "SOFTWARE_PROFICIENCY",
  //     soft_skills: "TEAMWORK_COLLABORATION",
  //     experience_fit: "Average Fit",
  //     candidate_rating: 3,
  //     candidateName: "Archana",
  //   },
  //   {
  //     id: 3,
  //     contactibility: "CALLED",
  //     communication: "WRITTEN_SKILLS",
  //     technical_skills: "SOFTWARE_PROFICIENCY",
  //     soft_skills: "TEAMWORK_COLLABORATION",
  //     experience_fit: "Poor Fit",
  //     candidate_rating: 2,
  //     candidateName: "Archana",
  //   },
  // ];


  useEffect(() => {
    dispatch(
      getOnlineCourseRequest()
    );
  }, [dispatch]);


  const loadingCourse = useSelector(
    (state) => state.getOnlineCourseReducer.isLoading
  );

  const courseData = useSelector(
    (state) => state.getOnlineCourseReducer.data
  );

  console.log("courseData", courseData);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(
      getFeedbackRequest(
        currentPage,
        rowsPerPage,

      )
    );
  }, [dispatch, currentPage, rowsPerPage]);



  const currentFeedback = feedbackData || [];

  // const columns = [
  //   {
  //     name: "Job Title",
  //     short_column: "job_name",
  //     sortable: true,
  //     // grow: 3, // Allow this primary column the most space to grow
  //     // minWidth: '80px', // Ensure the title doesn't get overly squished
  //     cell: (row) =>
  //       row.job_name ? (
  //         // Wrapper div is crucial for reliable text-overflow ellipsis
  //         <div
  //           style={{
  //             width: '100%',
  //             whiteSpace: 'nowrap',
  //             overflow: 'hidden',
  //             textOverflow: 'ellipsis',
  //           }}
  //           title={capitalize(row.job_name)} // The tooltip shows the full title on hover
  //         >
  //           <Link
  //             to={`${process.env.PUBLIC_URL}/jobseeker/job_details/${generateSlug(
  //               row.job_name,
  //               row.job_location,
  //               formatExperienceOutput(
  //                 row.work_experience_min,
  //                 row.work_experience_max
  //               ).replace("-", "-to-"),
  //               row.job_id
  //             )}`}
  //           >
  //             {capitalize(row.job_name)}
  //           </Link>
  //         </div>
  //       ) : (
  //         "-"
  //       ),
  //   },
  //   {
  //     name: "Contactibility",
  //     selector: (row) =>
  //       contactibilityOptions.find((opt) => opt.value === row.contactibility)
  //         ?.label || "",
  //     sortable: true,
  //     short_column: "contactability",
  //   },
  //   {
  //     name: "Communication",
  //     selector: (row) =>
  //       communicationsOptions.find((opt) => opt.value === row.communication)
  //         ?.label || "",
  //     sortable: true,
  //     short_column: "communication",
  //   },
  //   {
  //     name: "Technical Skills",
  //     selector: (row) => {
  //       const skills = row.technical_skills;
  //       return (skills && typeof skills === 'string'
  //         ? skills.split(",")
  //           .map((skill) =>
  //             technicalSkillsOptions.find((opt) => opt.value === skill.trim())
  //               ?.label
  //           )
  //           .filter(Boolean)
  //           .join(", ")
  //         : "") || ""; // Return empty string if skills is null or not a string
  //     },
  //     sortable: true,
  //     short_column: "technical_skills",
  //   },
  //   {
  //     name: "Soft Skills",
  //     selector: (row) => {
  //       const skills = row.soft_skills;
  //       return (skills && typeof skills === 'string'
  //         ? skills.split(",")
  //           .map((skill) =>
  //             softSkillsOptions.find((opt) => opt.value === skill.trim())?.label
  //           )
  //           .filter(Boolean)
  //           .join(", ")
  //         : "") || ""; // Return empty string if skills is null or not a string
  //     },
  //     sortable: true,
  //     short_column: "soft_skills",
  //   },
  //   {
  //     name: "Experience Fit",
  //     selector: (row) =>
  //       experienceFitOptions.find((opt) => opt.value === row.experience_fit)
  //         ?.label || "",
  //     sortable: true,
  //     short_column: "experience_fit",
  //   },
  //   {
  //     name: "Overall Rating",
  //     selector: (row) => `${row.candidate_rating}/5`,
  //     sortable: true,
  //     short_column: "rating",
  //   },
  // ];

  const columns = [
    {
      name: "Skill Category",
      selector: (row) => row.skill_key || "",
      sortable: true,
      short_column: "skill_key",
    },
    {
      name: "Skill Feedback",
      selector: (row) => row.value || "",
      sortable: true,
      short_column: "value",
    },
    {
      name: "Target Skill",
      selector: (row) => row.target_rating || "",
      sortable: true,
      short_column: "target_rating",
    },
    {
      name: "Feedback Type",
      selector: (row) => row.type || "",
      sortable: true,
      short_column: "type",
    },
  ];

  // Define skills to courses mapping
  // const skillsToCourses = {
  //   TEAMWORK_COLLABORATION: ["JavaScript Basics"],
  //   PROBLEM_SOLVING: ["React - The Complete Guide"],
  //   ADAPTABILITY: ["Node.js for Beginners"],
  //   LEADERSHIP_POTENTIAL: ["JavaScript Basics"],
  //   SOFTWARE_PROFICIENCY: ["React - The Complete Guide"],
  //   CODING_LANGUAGES: ["Web Dev Master"],
  //   INDUSTRY_KNOWLEDGE: ["Python for Data Science and ML"],
  //   DATA_ANALYSIS: ["React - The Complete Guide"],
  // };

  // const recommendedSkills = currentFeedback
  //   .filter((feedback) => feedback.candidate_rating < 5)
  //   .flatMap((feedback) => [
  //     ...(Array.isArray(feedback.technical_skills)
  //       ? feedback.technical_skills
  //       : typeof feedback.technical_skills === 'string'
  //         ? feedback.technical_skills.split(",")
  //         : []), // Return an empty array if it's null or not a string
  //     ...(Array.isArray(feedback.soft_skills)
  //       ? feedback.soft_skills
  //       : typeof feedback.soft_skills === 'string'
  //         ? feedback.soft_skills.split(",")
  //         : []), // Return an empty array if it's null or not a string
  //   ]);

  // const recommendedCourseNames = Array.from(new Set(recommendedSkills))
  //   .flatMap((skill) => skillsToCourses[skill.trim()] || [])
  //   .filter((course, index, self) => self.indexOf(course) === index);

  // const recommendedCourses = courseData.filter((course) =>
  //   recommendedCourseNames.includes(course.title)
  // );
  const recommendedCourses = courseData;

  // const sliderSettings = {
  //   dots: false,
  //   infinite: recommendedCourses.length > 1,
  //   speed: 500,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1,
  //       },
  //     },
  //   ],
  // };

  const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1, // Still needed, but swipe is handled separately
  swipeToSlide: true, // ✅ Allows user to control how many to scroll
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        swipeToSlide: true,
      },
    },
  ],
};



  const handleSort = async (column, direction) => {
    console.log("column", column);

    try {
      const page = currentPage;
      const per_page = rowsPerPage;
      const short_by = column.short_column;
      const column_direction = direction;

      dispatch(
        getFeedbackRequest(
          page,
          per_page,
          {},
          short_by,
          column_direction
        )
      );
    } catch (error) {
      console.error("Error fetching sorted data:", error);
    }
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  };

  return (
    <Fragment>

      <CourseCardStyles />
      <Breadcrumbs title="Candidate Feedback" mainTitle="Candidate Feedback" />
      <Container className="mt-4">
        <Row>
          <Col sm="12">
            <div className="feedback-container">
              {currentFeedback.length > 0 ? (
                <DataTable
                  columns={columns}
                  data={currentFeedback}
                  pagination
                  paginationServer
                  paginationPerPage={rowsPerPage}

                  paginationTotalRows={totalFeedbackCount}

                  onChangePage={(page) => setCurrentPage(page)}
                  onChangeRowsPerPage={handlePerRowsChange}
                  highlightOnHover
                  striped
                  headerComponent={CustomHeader}
                  progressPending={loadingFeedback}
                  progressComponent={<Spinner />}
                  noDataComponent={
                    <NoDataFound message={"No applied jobs found"} />
                  }
                  onSort={(column, direction) => handleSort(column, direction)}
                />
              ) : (
                <Card>
                  <NoDataFound />
                </Card>
              )}
            </div>
            {recommendedCourses.length > 0 && (
              <div className="mt-4">
                <h5 style={{ fontWeight: "bold", marginBottom: "20px" }}>
                  Recommended Courses:
                </h5>
                <Slider {...sliderSettings}>
                  {recommendedCourses.map((course) => (
                    <CourseCard key={course.uuid} course={course} />
                  ))}
                </Slider>

              </div>
            )}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default JobseekerFeedbackPage;
